import { type FC } from 'react';

import { Tag, Tooltip, TooltipBody } from '@wk/components-react16';

import type { Application } from '@/domains/application/application.types';

interface OnboardApplicationDetailsProps {
  application?: Application;
}

const OnboardApplicationDetails: FC<OnboardApplicationDetailsProps> = ({
  application,
}) => {
  if (!application) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 border-b border-gray-400 pb-6 max-sm:pb-4">
      <h3 className="text-lg font-medium">Application Details</h3>
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 sm:flex sm:flex-wrap sm:gap-x-20 sm:gap-y-3">
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">BIT ID</span>
          <span className="text-xs">{application.bitId}</span>
        </div>
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">Name</span>
          <span className="text-xs flex flex-wrap items-center gap-2">
            {application.name}
            {application.hostingModel === 'SaaS' ? (
              <>
                <Tooltip position="top" targetSelector="#hosting-model">
                  <TooltipBody slot="tooltipBody">
                    This is a SaaS application.
                  </TooltipBody>
                </Tooltip>
                <span id="hosting-model">
                  <Tag color="blue">{application.hostingModel}</Tag>
                </span>
              </>
            ) : null}
          </span>
        </div>
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">Division</span>
          <span className="text-xs">{application.division}</span>
        </div>
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">Business Critical</span>
          <span className="text-xs">
            {application.isBusinessCritical ? 'Yes' : 'No'}
          </span>
        </div>
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">App Ops</span>
          <span className="text-xs">{application.appOps}</span>
        </div>
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">DB Ops</span>
          <span className="text-xs">{application.dbOps}</span>
        </div>
        <div className="flex min-w-0 flex-col sm:w-[300px]">
          <span className="text-xs font-medium">Infra Ops</span>
          <span className="text-xs">{application.infraOps}</span>
        </div>
        <div className="col-span-2 flex min-w-0 flex-col sm:w-[300px] sm:flex-1">
          <span className="text-xs font-medium">Description</span>
          <span className="text-xs">{application.description}</span>
        </div>
      </div>
    </div>
  );
};

export default OnboardApplicationDetails;
